module.exports = __webpack_public_path__ + "static/media/ff_pipelines.165eec78.png";